import { withInstall } from "@xplus/utils/with-install";
import rate from "./src/rate.vue";
export const xRate = withInstall(rate);
export default xRate;
export * from "./src/rate";
